import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import "./Inbox.css";

const Inbox = () => {
  const { currentUser } = useAuth();
  const [chats, setChats] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser?.uid) return;

    const q = query(
      collection(db, "Chats"),
      where("participants", "array-contains", currentUser.uid),
      orderBy("lastUpdated", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const chatList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log("Chat list:", chatList); // Debugging the list of chats
      setChats(chatList);
    }, (error) => {
      console.error("Error fetching chats:", error); // Better error handling
    });

    return () => unsubscribe();
  }, [currentUser]);

  const goToChat = (chatId) => {
    navigate(`/inbox/${chatId}`);
  };

  const isTyping = (chat) =>
    chat.typingStatus?.userIdTyping &&
    chat.typingStatus.userIdTyping !== currentUser?.uid;

  const hasUnreadMessages = (chat) =>
    chat.unreadBy && chat.unreadBy.includes(currentUser?.uid);

  return (
    <div className="inbox-container">
      {chats.length === 0 ? (
        <div className="empty-inbox">
          <img
            src="/empty-inbox.svg"
            alt="No chats"
            className="empty-inbox-image"
          />
          <p>No active chats yet.</p>
          <small>Start trading to begin conversations!</small>
        </div>
      ) : (
        <div className="chat-list">
          {chats.map((chat) => (
            <div
              key={chat.id}
              className="chat-card"
              onClick={() => goToChat(chat.id)}
            >
              <div className="chat-card-left">
                <div className="chat-avatar-wrapper">
                  <img
                    src={chat.tradeImageURL || "/placeholder-item.png"}
                    alt={chat.tradeTitle || "Trade Item"}
                    className="chat-item-thumbnail"
                  />
                  {chat.online && <span className="online-dot"></span>}
                </div>
                <div className="chat-info">
                  <h4>{chat.tradeTitle || "Untitled Trade"}</h4>
                  <p className="last-message">
                    {isTyping(chat) ? (
                      <span className="typing-text">Typing...</span>
                    ) : (
                      <>
                        {chat.lastMessage?.text || "No messages yet..."}
                        {chat.lastMessage?.status === "seen" && (
                          <span className="status-icon">👁️</span>
                        )}
                        {chat.lastMessage?.status === "delivered" && (
                          <span className="status-icon">✔️</span>
                        )}
                      </>
                    )}
                  </p>
                </div>
              </div>

              <div className="chat-meta">
                <small className="chat-date">
                  {chat.lastUpdated?.toDate
                    ? new Date(chat.lastUpdated.toDate()).toLocaleDateString()
                    : ""}
                </small>
                {hasUnreadMessages(chat) && (
                  <span className="unread-badge">New</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Inbox;
